<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import solicitacaoContratacaoPessoalServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import Eventos from './compartilhado/FormEventos.vue';
  import DadosContratacao from './compartilhado/FormDadosContratacao.vue';
  import ResumoEventos from './compartilhado/FormResumoEventos.vue';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { DadosCadastrais, DadosBancarios, DadosContratacao, Eventos, AdicionarArquivos, ListaDeArquivos, ResumoEventos, Radio },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [],
        desabilitarBeneficiario: false,
        erroArquivos: false,
        usuario: this.$storage.usuario(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Contratação Pessoal - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-contratacao-pessoal.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.cpf)
          return false;

        return pessoaServico
          .busca(this.solicitacao.cpf)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');

        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.solicitacao.cpf = pessoa.cpfCnpj;
            this.solicitacao.nomeRequerinte = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.telefone = pessoa.telefone1;
            this.solicitacao.celular = pessoa.telefone2;
            this.solicitacao.email = pessoa.email.substring(0, 300);
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;
            this.solicitacao.endereco = pessoa.endereco;
            this.solicitacao.numero = pessoa.numero;
            this.solicitacao.complemento = pessoa.complemento;
            this.solicitacao.bairro = pessoa.bairro;
            this.solicitacao.cidade = pessoa.cidade;
            this.solicitacao.uf = pessoa.estado;
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');
            
            this.solicitacao.cpf = this.documento;

            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(() => {
            if (this.solicitacao.tipoSolicitacao === "0") {
              this.$swal(
                '',
                'É necessário informar um tipo de solicitação (Celetista ou estagiário).',
                'info'
              );

              throw new Error("validacao");
              exit;
            }
          })
          .then(this.buscarBeneficiario)
          .then(this.eventos = [])
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      camposSolicitacao() {
        return {
          idProjeto: null,
          nomeRequerinte: '', 
          cpf: '', 
          email: null, 
          telefone: '', 
          celular: '', 
          agencia: '', 
          banco: '', 
          conta: '', 
          tipoConta: '',
          tipoPix: '',
          chavePix: '',
          eventos: [],
          dataNascimento: '', 
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          cep: null,
          uf: '', 
          justificativaContratacao: '',
          funcao: '',
          horarioTrabalho: '',
          horarioDenscanso: '',
          dataInicioContratacao: '',
          localTrabalho: '',
          telefoneTrabalho: '',
          salarioBruto: null,
          vinculoFundacao: null,
          percentualEncargo: null,
          tipoSolicitacao: '0',
          aceite: '',
          observacaoCancelamento: '',
          projeto: {
            nomeProjeto: '',
            valorLimiteCompraDireta: null,
            permiteUtilizarCompraDireta: false,
            utilizarMetaEtapaProjeto: false,
            percentualEncargo: null,
          }
        }
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolContratacaoPessoal || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolContratacaoPessoal.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');

        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.$refs.dadosContratacao.validar)          
          .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-contratacao"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
           })
           .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(this.validarSePossuiEvento)
          .then(this.validarValorTotalProjeto)
          .then(this.validarArquivos)
          .then(valido => {
            if (!valido) {
              this.erroArquivos = true;
              $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-contratacao-pessoal.relatorio', id, 'solicitacao-contratacao-pessoal');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            if (!this.erroArquivos) {
              this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
            }

            this.erroArquivos = false;
          });
      },
      validarSePossuiEvento(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.$refs.eventos.possuiEventosObrigatorios()) return true;

        $('#tabs a[href="#tab-eventos"]').tab('show');
        
        this.$swal(
          '',
          'É necessário selecionar todos os benefícios "Obrigatórios".',
          'info'
        );

        throw new Error("validacao");
      },
      validarArquivos() {
        if (this.configuracao.obrigatorioArquivoSolContratacaoPessoal) {
          const faltaArquivo = !this.$refs.adicionarArquivos.existeArquivo();

          if (this.arquivos.length === 0 && faltaArquivo) {
            var texto = "Adicione pelo menos um arquivo na solicitação! <br>";

            this.$swal({
              title: 'Falta de Arquivos',
              html: texto,
              type: 'error',
              confirmButtonText: 'Ok, entendi!',
              allowOutsideClick: false,
              allowEscapeKey: false,
            });

            return false;
          }
        }
        return true;
      },
      validarValorTotalProjeto(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.solicitacao.aceite) return true;

        $('#tabs a[href="#tab-resumo"]').tab('show');

        this.$refs.resumo.adicionaErroAceite();

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        if (this.$route.params.id) {
          return solicitacaoContratacaoPessoalServico.alterar(copiaSolicitacao, arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoContratacaoPessoalServico.adicionar(copiaSolicitacao, arquivos);
        }
      },
      download(arquivo) {
        solicitacaoContratacaoPessoalServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoContratacaoPessoalServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.cpf);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.cpf);
          })
          .then(() => solicitacaoContratacaoPessoalServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();
            if (solicitacao.tipoConta != null)
              this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));
            this.carregando = false;
            this.$refs.eventos.listaDeEventos(solicitacao.tipoSolicitacao);
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">

        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
        </div>

        <div class="alert alert-warning" role="alert" v-show="solicitacao.observacaoCancelamento">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group no-margins">
                <dl class="col-xs-12">
                  <dt>Observação recusa</dt>
                  <dd v-html="nl2br(solicitacao.observacaoCancelamento)">
                    {{ nl2br(solicitacao.observacaoCancelamento) }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="tabs-container" v-show="!carregando" id="tabs">

          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab"
                 href="#tab-dados-cadastrais">
                Dados cadastrais
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-dados-contratacao">
                Dados contratação
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-dados-bancarios">
                Dados bancários
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-eventos">
                Benefícios
              </a>
            </li>
            <li>
              <a data-toggle="tab"
                 href="#tab-resumo">
                Resumo contratação
              </a>
            </li>
            <li v-if="configuracao.usarArquivosSolicitacaoContratacaoPessoal">
              <a data-toggle="tab"
                 href="#tab-adicionar-arquivos">
                Adicionar arquivos
              </a>
            </li>
            <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoContratacaoPessoal">
              <a data-toggle="tab"
                 href="#tab-lista-arquivos">
                Arquivos
              </a>
            </li>
          </ul>
          <div class="tab-content">

            <div id="tab-dados-cadastrais" class="tab-pane active">
              <div class="panel-body">
                <dados-cadastrais ref="dadosCadastrais"
                                  :solicitacao="solicitacao"
                                  :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                  :edicao="!!$route.params.id">
                </dados-cadastrais>
              </div>
            </div>

            <div id="tab-dados-contratacao" class="tab-pane">
              <div class="panel-body">
                <dados-contratacao ref="dadosContratacao"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id">
                </dados-contratacao>
              </div>
            </div>

            <div id="tab-dados-bancarios" class="tab-pane">
              <div class="panel-body">
                <dados-bancarios ref="dadosBancarios"
                                 :solicitacao="solicitacao"
                                 :edicao="!!$route.params.id"
                                 :dadosBancarios="dadosBancarios"
                                 :dadosBancariosPIX="dadosBancariosPIX">
                </dados-bancarios>
              </div>
            </div>

            <div id="tab-eventos" class="tab-pane">
              <div class="panel-body">
                <eventos ref="eventos"
                         :solicitacao="solicitacao"
                         :edicao="!!$route.params.id">
                </eventos>
              </div>
            </div>

            <div id="tab-resumo" class="tab-pane">
              <div class="panel-body">
                <resumo-eventos ref="resumo"
                         :solicitacao.sync="solicitacao">
                </resumo-eventos>
              </div>
            </div>

            <div id="tab-adicionar-arquivos" class="tab-pane">
              <div class="panel-body">
                <div class="alert alert-warning" role="alert" v-if="configuracao.solContratacaoPessoalMsgArquivo">
                  <div class="row">
                    <dl class="col-xs-12">
                      <dt></dt>
                      <dd v-html="configuracao.solContratacaoPessoalMsgArquivo">
                        {{ configuracao.solContratacaoPessoalMsgArquivo }}
                      </dd>
                    </dl>
                  </div>
                </div>

                <adicionar-arquivos ref="adicionarArquivos">
                </adicionar-arquivos>
              </div>
            </div>

            <div id="tab-lista-arquivos" class="tab-pane">
              <div class="panel-body">
                <lista-de-arquivos :arquivos="arquivos"
                                   @download="download"
                                   ref="listaArquivos">
                </lista-de-arquivos>
              </div>
            </div>

          </div>
          
        </div>
        
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-10">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CPF do Beneficiário</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="documento"
                   data-vv-name="documento"
                   v-mascara="'cpf'"
                   v-validate="'required|cpf'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
        
        <div class="col-sm-2">
          <div class="form-group required" :class="{'has-error': errors.has('tipo')}">
            <label class="control-label block">Tipo solicitação</label>

            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="1"
                   type="success"
                   :inline="true"
                   class="margin-right-10">
              Celetista
            </radio>
            <radio v-model="solicitacao.tipoSolicitacao"
                   selected-value="2"
                   type="success"
                   :inline="true"
                   class="margin-right-10">
              Estagiário
            </radio>

            <p class="text-danger" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'solicitacao-contratacao-pessoal' }"
              v-show="!mostrarFormulario || !!$route.params.id"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="avancar"
              type="button"
              class="btn btn-primary"
              @click="validarBeneficiario"
              v-show="!mostrarFormulario"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button
              type="button"
              class="btn btn-default"
              @click="mostrarFormulario = false, resetarComponente()"
              v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              v-show="mostrarFormulario"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/SolicitacaoContratacaoPessoalForm.vue